import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import { FC, ReactNode, createContext, useContext, useRef, useState } from "react";

const LoadingContext = createContext({
    startLoading: () => { },
    stopLoading: () => { },
});

export const LoadingContextProvider: FC<{ children: ReactNode }> = ({ children }) => {

    const toastRef = useRef<Toast>(null);

    const [loading, setLoading] = useState(false);

    const startLoading = () => {
        setLoading(true);
    };
    
    const stopLoading = () => {
        setLoading(false);
    };

    return (
        <LoadingContext.Provider value={{ startLoading, stopLoading }}>
            {loading && <Dialog visible={loading} modal draggable={false}  closable={false} showHeader={false} onHide={() => { }}>
                <ProgressSpinner style={{ width: '100px', height: "100px", margin: 5 }} strokeWidth="4" fill="#EEEEEE" animationDuration=".5s" />
            </Dialog>}
            <div>{children}</div>
        </LoadingContext.Provider>
    );
};

export const useLoadingContext = () => {
    const context = useContext(LoadingContext);

    if (!context) {
        throw new Error(
            "useLoadingContect have to be used within LoadingContextProvider"
        );
    }

    return context;
};
